import { XMarkIcon } from "@heroicons/react/20/solid";
import { get } from "lodash";
import { useLayoutEffect, useRef, useState } from "react";
import { connect } from "react-redux";

const Modal = ({ isOpen, title, close, width = "60%", color = "bg-primary-dark", children }) => {
	const modalRef = useRef(null);
	const screenHeight = window.innerHeight;

	const [margin, setMargin] = useState(20);

	useLayoutEffect(() => {
		if (modalRef.current) {
			const height = modalRef.current.clientHeight;
			const newMargin = (screenHeight - height) / 4;

			setMargin(Math.max(newMargin, 20));
		} else {
			setMargin(20);
		}
	}, [isOpen, children, modalRef.current?.clientHeight, screenHeight]);

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden={!isOpen}
			style={{
				visibility: isOpen ? "visible" : "hidden",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				background: "rgba(0,0,0,0.4)",
				overflow: "auto",
				transition: `opacity 0.${isOpen ? 4 : 2}s ease-in-out, visibility 0.${isOpen ? 4 : 2}s ease-in-out`,
				opacity: isOpen ? 1 : 0,
				pointerEvents: isOpen ? "auto" : "none",
				overflow: "hidden",
			}}
		>
			<div
				className={`modal-dialog`}
				style={{
					borderRadius: 20,
					width,
					background: "transparent",
					bottom: margin,
					transition: "bottom 0.3s ease-in-out",
				}}
			>
				<div
					ref={modalRef}
					className="modal-content"
					style={{
						background: "white",
						borderRadius: 11,
						maxHeight: "95vh",
						overflowY: "visible",
						scrollbarWidth: "none",
						msOverflowStyle: "none",
						margin: -1,
					}}
				>
					<div className="block block-themed block-transparent remove-margin-b p-0">
						<div
							className={`block-header ${color} p-8`}
							style={{
								position: "sticky",
								top: 0,
								zIndex: 50,
								margin: -1,
								boxShadow: "0 4px 4px rgba(0, 0, 0, 0.2)",
								borderRadius: "10px 10px 0px 0px",
							}}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={close}
									>
										<XMarkIcon className="h-10 w-10 mr-3 text-white hover:rotate-180 transition-transform duration-200" />
									</button>
								</li>
							</ul>
							<h3
								className="block-title"
								style={{ fontSize: "16px" }}
							>
								{title}
							</h3>
						</div>
						<style jsx>{`
							/* Custom scrollbar styles for WebKit browsers */
							.block-content::-webkit-scrollbar {
								width: 6px; /* Reduced width */
							}

							.block-content::-webkit-scrollbar-track {
								background: #f1f1f1;
								border-radius: 10px;
								margin-bottom: 15px; /* Add margin to the bottom */
							}

							.block-content::-webkit-scrollbar-thumb {
								background: #888;
								border-radius: 10px;
							}

							.block-content::-webkit-scrollbar-thumb:hover {
								background: #555;
							}

							/* Add padding to the container to avoid overlap with rounded corners */
							.block-content {
								padding-right: 10px; /* Adjust as needed */
							}
						`}</style>
						{children}
						<div className="clearfix" />
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const isOpen = typeof ownProps.status === "string" ? get(state, ownProps.status) : ownProps.status;

	return {
		isOpen,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
